module.exports = __webpack_public_path__ + "ce7fa160.webp";